/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */
import type { QueryFunction, QueryKey, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { ProblemDetails, UserRecord } from '../../model';
import type { ErrorType } from '../../utils/UseCustomInstance';
import { useCustomInstance } from '../../utils/UseCustomInstance';

export const useGetAllCollaborationUserRecordsHook = () => {
    const getAllCollaborationUserRecords = useCustomInstance<UserRecord[]>();

    return (signal?: AbortSignal) => {
        return getAllCollaborationUserRecords({ url: `/Users/GetAllCollaborationUserRecords`, method: 'get', signal });
    };
};

export const getGetAllCollaborationUserRecordsQueryKey = () => [`/Users/GetAllCollaborationUserRecords`] as const;

export const useGetAllCollaborationUserRecordsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAllCollaborationUserRecordsHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllCollaborationUserRecordsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllCollaborationUserRecordsHook>>>, TError, TData> & {
    queryKey: QueryKey;
} => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAllCollaborationUserRecordsQueryKey();

    const getAllCollaborationUserRecords = useGetAllCollaborationUserRecordsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAllCollaborationUserRecordsHook>>>> = ({ signal }) =>
        getAllCollaborationUserRecords(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetAllCollaborationUserRecordsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetAllCollaborationUserRecordsHook>>>
>;
export type GetAllCollaborationUserRecordsQueryError = ErrorType<unknown>;

export const useGetAllCollaborationUserRecords = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAllCollaborationUserRecordsHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllCollaborationUserRecordsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetAllCollaborationUserRecordsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useRefreshTokenHook = () => {
    const refreshToken = useCustomInstance<string>();

    return (signal?: AbortSignal) => {
        return refreshToken({ url: `/Users/RefreshToken`, method: 'get', signal });
    };
};

export const getRefreshTokenQueryKey = () => [`/Users/RefreshToken`] as const;

export const useRefreshTokenQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useRefreshTokenHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRefreshTokenHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRefreshTokenHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getRefreshTokenQueryKey();

    const refreshToken = useRefreshTokenHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useRefreshTokenHook>>>> = ({ signal }) => refreshToken(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type RefreshTokenQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRefreshTokenHook>>>>;
export type RefreshTokenQueryError = ErrorType<ProblemDetails>;

export const useRefreshToken = <
    TData = Awaited<ReturnType<ReturnType<typeof useRefreshTokenHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRefreshTokenHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useRefreshTokenQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};
